import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPreview = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M13.334 13.06V5.333l-4-4H4c-.733 0-1.326.6-1.326 1.334l-.007 10.666c0 .734.593 1.334 1.327 1.334H12c.3 0 .567-.1.794-.267L9.84 11.447C9.307 11.793 8.68 12 8 12c-1.84 0-3.333-1.493-3.333-3.333S6.16 5.333 8 5.333s3.334 1.494 3.334 3.334c0 .68-.207 1.306-.554 1.833l2.554 2.56zM6 8.667c0 1.106.894 2 2 2 1.107 0 2-.894 2-2 0-1.107-.893-2-2-2-1.106 0-2 .893-2 2z"
	})
});
export default SvgIconPreview;
